import { apiFetch } from "./client";

export function getCart(userId) {
  return apiFetch(`/api/user/${encodeURIComponent(userId)}/cart`);
}

export function addCartItem(userId, body) {
  return apiFetch(`/api/user/${encodeURIComponent(userId)}/cart/items`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function updateCartItemQuantity(userId, cartItemId, quantity) {
  const q = Number(quantity);
  return apiFetch(
    `/api/user/${encodeURIComponent(userId)}/cart/item/${encodeURIComponent(cartItemId)}`,
    {
      method: "POST",
      body: JSON.stringify({ quantity: q }),
    }
  );
}

export function deleteCartItem(userId, cartItemId) {
  return apiFetch(
    `/api/user/${encodeURIComponent(userId)}/cart/item/${encodeURIComponent(cartItemId)}`,
    { method: "DELETE" }
  );
}
